import script from "./orderHistoryTab.vue?vue&type=script&setup=true&name=orderHistoryTab&lang=js"
export * from "./orderHistoryTab.vue?vue&type=script&setup=true&name=orderHistoryTab&lang=js"

const __exports__ = script;

export default __exports__